import { ToggleGroup, ToggleGroupItem } from "@fox1ck-org/ui";

interface EnvToggleProps {
  value: "prod" | "dev";
  onChange: (value: "prod" | "dev") => void;
}

export function EnvToggle({ value, onChange }: EnvToggleProps) {
  return (
    <ToggleGroup
      type="single"
      value={value}
      onValueChange={(v) => v && onChange(v as "prod" | "dev")}
      size="sm"
    >
      <ToggleGroupItem value="prod">Прод</ToggleGroupItem>
      <ToggleGroupItem value="dev">Дев</ToggleGroupItem>
    </ToggleGroup>
  );
}
